import { connect } from 'react-redux';
import { fetchReviewsByStationId } from '../../actions/reviews';
import VerboseStationInfo from './VerboseStationInfo';

const RECENT_REVIEWS_TO_DISPLAY = 1;

function mapStateToProps({ reviews: reviewsState }, { stationId }) {
  const stationReviews = reviewsState.byStationId[stationId] || [];
  const recentReviews = stationReviews.slice(0, Math.min(RECENT_REVIEWS_TO_DISPLAY, stationReviews.length));
  const reviews = recentReviews.map(review => reviewsState.byId[review]);

  return {
    reviews,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchReviewsByStationId: stationId => dispatch(fetchReviewsByStationId(stationId, 0, RECENT_REVIEWS_TO_DISPLAY)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(VerboseStationInfo);
